import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA  } from '@angular/material/dialog';

@Component({
    selector   : 'fuse-message-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrls  : ['./message-dialog.component.scss']
})
export class FuseMessageDialogComponent
{
    public message: string;
    public title: string;

    constructor(public dialogRef: MatDialogRef<FuseMessageDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: MessageDialogModel) {
        this.title = data.title;
        this.message = data.message;
    }    

}

export class MessageDialogModel {

  constructor(public title: string, public message: string) {
  }
}
